import { Suspense, lazy } from "react";

// Loaded on demand: the page uses the platform's own page parts, which the
// package entry must not pull in.
const Page = lazy(() => import("./ApprovalsPage").then((m) => ({ default: m.ApprovalsPage })));

export const ApprovalsRoute = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

// A tab of the Organization page, beside Policies. Managers see it too:
// it is where they ask, and see what they asked for.
export const approvalsTab = {
  key: "approvals",
  label: "Approvals",
  path: "/approvals",
  component: ApprovalsRoute,
  when: "manager",
  after: "policies",
};
